import { useEffect, useState } from 'react';
import BitflowBannerImage from 'images/bitflowBanner.svg';
import BitflowBannerImageNoBg from 'images/bitflowBannerNoBg.svg';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
  };
}

export const BitflowBanner = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions.width > 2000 ? (
    <a
      style={{
        background: 'linear-gradient(to right, #F56B25 25.5%, #23262B 47%)',
        borderRadius: '16px',
        display: 'block',
      }}
      href="https://app.bitflow.finance/sbtc#earn3"
      rel="noopener noreferrer"
      target="_blank"
    >
      <img src={BitflowBannerImageNoBg} style={{ height: '184px', width: '100%' }} />
    </a>
  ) : (
    <a href="https://app.bitflow.finance/sbtc#earn3" rel="noopener noreferrer" target="_blank">
      <img src={BitflowBannerImage} style={{ height: '184px', width: '100%' }} />
    </a>
  );
};
